import type { RouteRecordRaw } from 'vue-router'
import  AdPage  from '../../pages/Ad.vue'
import {ROUTES} from '@myorg/type-lib'


export const AdRoute: RouteRecordRaw = {
  path: ROUTES.ABOUT.PATH,
  name: ROUTES.ABOUT.NAME,
  component: AdPage,
}
